import React, { useState, useEffect } from "react";
import { PropTypes } from "prop-types";

import VariableInput from "./VariableInput";

import "css/admin/variable_list.scss";

function VariableList({ isDisabled, variables, onChange }) {
  const [variablesArray, setVariableArray] = useState([{ key: "", value: "" }]);

  useEffect(() => {
    const arr = [];

    if (variables) {
      Object.entries(variables).forEach(([key, value]) => {
        arr.push({ key, value });
      });

      setVariableArray(arr);
    }
  }, [variables]);

  useEffect(() => {
    const last_variable = variablesArray[variablesArray.length - 1];

    if (!last_variable || last_variable.key || last_variable.value) {
      setVariableArray([...variablesArray, { key: "", value: "" }]);
    }
  }, [variablesArray]);

  const convertArrToObj = () => {
    const obj = {};

    variablesArray.forEach((variable) => {
      if (variable.key) {
        obj[variable.key] = variable.value;
      }
    });

    return obj;
  };

  const onChangeVariable = (value, type, index) => {
    const newVariables = variablesArray;

    newVariables[index][type] = value;

    onChange(convertArrToObj(newVariables));
  };

  const removeVariable = (index) => {
    if (variablesArray.length > 1) {
      variablesArray.splice(index, 1);
      onChange(convertArrToObj(variables));
    } else {
      onChange(convertArrToObj([{ key: "", value: "" }]));
    }
  };

  return (
    <div className="variable-list-container">
      {variablesArray?.map((variable, i) => (
        <VariableInput
          key={`variable-input-${i}`}
          disabled={isDisabled}
          index={i}
          variable={variable}
          onChange={onChangeVariable}
          onRemove={removeVariable}
        />
      ))}
    </div>
  );
}

VariableList.propTypes = {
  isDisabled: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  variables: PropTypes.array,
};

VariableList.defaultProps = {
  isDisabled: false,
};

export default VariableList;
